<template>
  <!-- Modal terms -->
  <div
    id="information-summary-modal"
    aria-hidden="false"
    aria-labelledby="information-summary-modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('Şirket Başvurusunu İnceleyin') }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 class="main-information-header">{{ $t('Şirket Bilgileriniz') }}</h3>
          <div class="list-item">
            <p class="company-data-header">{{ $t('Şirket İsmi') }}:</p>
            <p class="company-data-text">{{ companyInformations.name }}</p>
          </div>
          <div class="list-item">
            <p class="company-data-header">{{ $t('Şirket Türü') }}:</p>
            <p class="company-data-text">{{ companyInformations.companyType.data.name }}</p>
          </div>

          <h3 class="main-information-header mt-3">{{ $t('Kişisel Bilgileriniz (Ortak)') }}</h3>
          <div class="list-item">
            <p class="company-data-header">{{ $t('Ad') }}:</p>
            <p class="company-data-text">{{ form.fullname }}</p>
            <p v-if="companyInformations.partnership_details" class="percentage-text">({{ usersCompanyPercent }}%)</p>
          </div>
          <div class="list-item">
            <p class="company-data-header">{{ $t('E-posta') }}:</p>
            <p class="company-data-text">{{ form.email }}</p>
          </div>
          <div v-if="form.mobile" class="list-item">
            <p class="company-data-header">{{ $t('Cep Telefonu Numarası') }}:</p>
            <p class="company-data-text">{{ form.mobile }}</p>
          </div>
          <div v-if="form.birthday" class="list-item">
            <p class="company-data-header">{{ $t('Doğum Tarihi (aa/gg/yyyy)') }}:</p>
            <p class="company-data-text">{{ form.birthday }}</p>
          </div>
          <div class="list-item">
            <p class="company-data-header">{{ $t('Milliyet Bilgileriniz') }}:</p>
            <p class="company-data-text">{{ form.nationality }}</p>
          </div>
          <div class="list-item">
            <p class="company-data-header">{{ $t('Ikamet Bilgileriniz') }}:</p>
            <p class="company-data-text">{{ form.address.country }}</p>
          </div>
          <div v-if="companyInformations.partnership_details.length && companyInformations.partnership_details[0].name">
            <h3 class="main-information-header mt-3">{{ $t('Diger Ortaklar') }}</h3>
            <div v-for="(shareholder, index) in companyInformations.partnership_details" :key="index" class="mb-2">
              <div>
                <p class="company-data-text">{{ $t('Ortak') }} #{{ index + 1 }}</p>
              </div>
              <div class="d-flex">
                <p class="company-data-header">{{ $t('Ad') }} :</p>
                <p class="company-data-text">{{ shareholder.name }} {{ shareholder.surname }}</p>
                <p class="percentage-text">({{ shareholder.percent }}%)</p>
              </div>
              <div class="d-flex">
                <p class="company-data-header">{{ $t('Cep Telefonu Numarası') }} :</p>
                <p class="company-data-text">{{ shareholder.mobile }}</p>
              </div>
            </div>
          </div>

          <div v-if="companyInformations.director_details.length && companyInformations.director_details[0].name">
            <h3 class="main-information-header mt-3">{{ $t('Direktör bilgileri') }}</h3>
            <div v-for="(director, index) in companyInformations.director_details" :key="index" class="mb-2">
              <div>
                <p class="company-data-text">{{ $t('Direktör') }} #{{ index + 1 }}</p>
              </div>
              <div class="d-flex">
                <p class="company-data-header">{{ $t('Ad') }} :</p>
                <p class="company-data-text">{{ director.name }} {{ director.surname }}</p>
              </div>
              <div class="d-flex">
                <p class="company-data-header">{{ $t('Cep Telefonu Numarası') }} :</p>
                <p class="company-data-text">{{ director.mobile }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('Düzenle') }}</button>
          <button type="button" class="btn btn-mukellef" @click="sendForm()" data-dismiss="modal">
            {{ $t('Devam Et') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'InformationSummaryModal',
  props: {
    form: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    usersCompanyPercent() {
      let total = 0;
      this.companyInformations.partnership_details.forEach(function (element) {
        if (element.percent) {
          total += parseInt(element.percent);
        }
      });
      return 100 - total;
    },
    companyInformations() {
      if (this.form) {
        return this.form.companies.data[0];
      }
      return null;
    },
  },
  methods: {
    sendForm() {
      this.$emit('send-form');
    },
  },
};
</script>

<style scoped>
.list-item {
  display: flex;
}
.main-information-header {
  margin: 0 0 0.75rem 0;
  padding: 0;
  line-height: 24px;
  font-weight: 500;
  font-size: 1rem;
}
.company-data-header {
  margin-right: 0.25rem;
  font-size: 12px;
  vertical-align: middle;
  line-height: 20px;
}
p {
  margin-bottom: 0.15rem;
}
.percentage-text {
  margin-left: 0.25rem;
  color: #00aa6b;
  font-size: 13px;
}
.company-data-text {
  font-weight: 500;
}
</style>
